import React, {Fragment} from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Stars } from "./Stars/Stars";
import "./Rating.scss";

export const Rating = props => {
  const className = cx("rating", props.className);

  return (
    <div className={className}>
        <strong className="rating__source">
          <img src={props.ratingLogoSrc} className="rating__logo"  width="70" height="auto" alt="Reviews Logo" />
        </strong>
        {props.rating ? (
          <Fragment>
            <Stars className="rating__stars" rating={props.rating.value} />
            <div className="rating__value">{props.rating.displayValue}</div>
          </Fragment>
        ) : (
          <span className="rating__value rating__value--null">{props.ratingMeta.noRatingMessage}</span>
        )}
    </div>
  );
};
Rating.defaultProps = {
  rating: null,
};
Rating.propTypes = {
  rating: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  }),
};
